export const ErrorDependencyTypes = {
  CockpitApiErrorHandlerService: Symbol.for('CockpitApiErrorHandlerService'),
  CockpitApiErrorDataTransformerLocator: Symbol.for('CockpitApiErrorDataTransformerLocator'),
  ConstraintValidationApiErrorDataTransformer: Symbol.for('ConstraintValidationApiErrorDataTransformer'),
  UnknownApiErrorDataTransformer: Symbol.for('UnknownApiErrorDataTransformer'),
};
